import React, { useContext, useEffect, useRef, useState } from "react"
import { AccordionDetails, Badge, Box, ClickAwayListener, IconButton, Switch } from "@mui/material"
import MobileMenuIcon from "../../assets/images/icon/MobileMenuIcon"
import StrikeIcon from "../../assets/images/icon/StrikeIcon";
import { outcomeService } from "../../services/outcome";
import { UserTypeContext } from "../../context/userStatus";
import { userService } from "../../services/auth";
import moment from "moment";
import clsx from "clsx";
import { InfluenceGetResponse, OutcomeGetResponse, RefelectiveGetResponse } from "../../interfaces/outcomeModal";
import { addCategoryExpandAction, addCategoryJourneyAction, addInfluenceAction, addJourneyAction, addNotesAction, addNotesJourneyAction, addOutcomeAction, addRefelectiveAction, isPersonalMode, setUserHeart, setUserStreak } from "../../store/actions/userTypeAction";
import { influenceService } from "../../services/influence";
import { reflectiveQueService } from "../../services/reflective-questions";
import CommonTypo from "../../components/CommonTypo";
import { styled } from "@mui/material/styles";
import { notificationService } from "../../services/notifications";
import { trackingService } from "../../services/tracking";
import BellIcon from "../../assets/images/icon/BellIcon";
import useStyles from "./styles";
import Unavailablecategory from "./../tracker/Unavailablecategory";
import TabBox from "../../components/TabBox";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import HTMLTooltip from "../../components/HTMLTooltip";
import InfoIcon from "../../assets/images/icon/infoIconYellow";
import palette from "../../theme/palette";
import { pxToRem } from "../../theme/typography";
import ArrowUp from "../../assets/images/icon/arrow_up";
import AddTrackingEventModal from "../tracker/addTrackingEventModal";
import AddTrackingEventInfluenceModal from "../tracker/addTrackingEventInfluenceModal";

import AddHoursModal from "../tracker/addHoursModal";
import AddYesNoModal from "../tracker/addYesNoModal";
import AddTimeOfDay from "../tracker/addTimeOfDayModel";
import AddRefQuesModal from "../tracker/addRefQuesModal";
import DetailCard from "./DetailsCard";
import { setDayCompleteMessage, setTrackingState } from "../../store/actions/trackerAction";
import { TrackingContext } from "../../context/userTracking";
import SnackBarComp from "../../components/snackBar";
import useNotifications from "../../components/DayCompleteSnackBar";
import HeaderPopoverMobile from "../tracker/HeaderPopoverMobile";
import { useNavigate } from "react-router-dom";
import UnavailableCategoryV2 from "./UnavailablecategoryV2";
import PlusIconSVG from "../../assets/images/icon/PlusIcon";
import NotificationMobile from "../../assets/images/icon/NotificationMobile";
import GoogleFit from "../../assets/images/icon/integration/googleFit";
import OutcomeIcon from "../../assets/images/icon/ProgressInsights/OutcomeIcon";
import { FontAwesomeIconRender } from "../../components/IconSelectionPopOver";
import { baseEndpoints } from "../../services/config";
import StrikeIconV2 from "../../assets/images/icon/StrikeIconV2";
import { HeartBlankV2 } from "../../assets/images/icon/HeartBlank";
interface switchProps {
    onChange: any;
    checked: boolean;
}
const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 5,
        top: 0,
        background: '#B8E29E',
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 0px',
        fontSize: '0.0rem'
    },
}));
const IOSSwitch = styled((props: switchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 48,
    height: 24,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        position: "absolute !important",
        // margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(24px)",
            color: "var(--color-border)",
            "& + .MuiSwitch-track": {
                backgroundColor:
                    theme.palette.mode === "dark" ? "#2ECA45" : "var(--color-new-main)",
                opacity: 1,
                border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
            "& .MuiSwitch-thumb": {
                boxSizing: "border-box",
                width: 16,
                height: 16,
                backgroundColor: "var(--white-background)",
                margin: "4px",
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "var(--color-border)",
            border: "6px solid var(--color-border)",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 16,
        height: 16,
        backgroundColor: "var(--white-background)",
        margin: "4px",
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor:
            theme.palette.mode === "light" ? "var(--color-border)" : "#39393D",
        border: `1px solid var(--color-border)`,
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));
const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    backgroundColor: "transparent",
    "&:before": {
        display: "none",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        transform: "rotate(180deg)",
        marginLeft: "10px",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(0deg)",
    },
}));
const AccordionSummary = (props: AccordionSummaryProps & {
    tooltipTitle?: string;
    integrationType?: string;
    expanded?: boolean
    isToday?: boolean
    cat?: any
}) => {
    const [open, setOpen] = useState(false)
    const renderIcon = () => {
        let deaultImage = props?.cat?.integrationType && props?.cat?.integrationType === "TOGGL" ? "/toggl.png"
            : props?.cat?.integrationType && props?.cat?.integrationType === "WHOOP" ? "/whoop.png"
                : props?.cat?.integrationType && props?.cat?.integrationType === "OURA" ? "/oura.png" :
                    props?.cat?.integrationType && props?.cat?.integrationType === "GARMIN" ? "/garmin.svg" :
                        props?.cat?.integrationType && props?.cat?.integrationType === "GOOGLEFIT" ? <GoogleFit size={24} /> : <OutcomeIcon size={24} />
        return <>
            {props?.cat?.iconUrl && props?.cat.iconType === "IMAGE" ? (
                <img
                    alt="toggl"
                    width="16px" height="16px"
                    src={
                        props?.cat?.iconUrl
                            ? `${baseEndpoints.getImage}${props?.cat?.iconUrl}`
                            : "/toggl.png"
                    }
                    style={{
                        height: "16px",
                        width: "16px",
                        borderRadius: "10px"
                    }}
                />
            ) : props?.cat?.iconUrl && props?.cat.iconType === "ICON" ? (
                <FontAwesomeIconRender selectedIcon={props?.cat?.iconUrl} style={{ width: "16px", height: "16px" }} />
            ) : props?.cat?.iconUrl && props?.cat.iconType === "EMOJI" ? (
                <span style={{
                    height: "16px",
                    width: "16px",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>{props?.cat?.iconUrl}</span>
            ) : typeof deaultImage === "string" ? (
                <img width="16" height="16" src={"/toggl.png"} alt="toggl" style={{
                    borderRadius: "10px"
                }} />
            ) : null}
        </>
    }
    return (
        <div style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
        }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "16px",
                    height: "51px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        width: "100%",
                    }}
                >
                    {renderIcon()}
                    <div
                        // variant="h4"
                        style={{ fontWeight: 600, fontSize: "18px", lineHeight: "21.6px" }}
                    // fontWeight={600}
                    // className={classes.listTitle}
                    >
                        {props?.title}
                    </div>
                    {props?.tooltipTitle && (
                        <ClickAwayListener onClickAway={() => setOpen(false)}>
                            <IconButton
                                style={{
                                    padding: "0px",
                                    height: "20px",
                                    width: "20px"
                                }}

                                onClick={() => setOpen(!open)}
                            >
                                <HTMLTooltip placement={"bottom-start"} customIcon={<div><InfoIcon color={palette.primary.main} size={"14"} /></div>} title={props?.tooltipTitle} fontProps={{
                                    sx: {
                                        fontSize: `${pxToRem(14)} !important`,
                                        lineHeight: "120% !important",
                                        textAlign: "justify !important",
                                        "&.MuiTypography-root": {
                                            "@media  (max-width: 600px) and (min-width: 100px)": {
                                                fontSize: `${pxToRem(14)} !important`,
                                                lineHeight: "150% !important"
                                            },
                                        }
                                    }
                                }} sx={{
                                    '& .MuiTooltip-tooltip': {
                                        maxWidth: "350px",
                                        marginLeft: "20px",
                                        marginRight: "20px"
                                    }
                                }} customProps={{
                                    placement: "bottom-end",
                                    open: open
                                }} />
                            </IconButton>
                        </ClickAwayListener>

                    )}


                </div>
                <MuiAccordionSummary
                    expandIcon={<ArrowUp color="#292B2A" />}
                    {...props}
                    style={{ padding: "0px" }}
                />
            </div>
            {props?.integrationType && props?.integrationType !== "GENERAL" && props?.expanded && props?.isToday && (
                <Box display={"flex"} width={"100%"} borderRadius={"12px"} gap={"8px"} padding={"16px"} sx={{
                    background: "#FFB378"
                }}>
                    <CommonTypo>The integration shares your data at midnight</CommonTypo>
                </Box>
            )}

        </div>

    );
};
let alreadyCalled = false
const MobileScreen = ({
    createDate,
    setCreateDate,
    setAddOutcomeTracking,
    setStartModal,
    setStartModalInfluence,
    setStartModalQues,
    setAddInfluenceTracking,
    setAddQuesTracking,
    setOutcomeIdeas,
    setInfluenceIdeas,
    setReflectiveIdeas,
    setShowLoader,
    setOutcomeValue,
    setInfluenceData,
    setQuestionData,
    setMobileEndDay,
    setMobileStartDay,
    setLimitReachPopupVisible,
    setLimitReachPopuptype,
    betweenDate = moment()
}) => {
    const navigate = useNavigate()
    const { Notification } = useNotifications();
    const { state: outcomeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const { dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const currentDateRef = useRef(null)
    const [categoryId, setCategoryId] = useState<any>();
    const [showSnakbar, setShowSnakbar] = useState(false);
    const [snakbarMsg, setSnakbarMsg] = useState("");
    const [msgType, setMsgType] = useState("");
    const [openUnavailablecategoryMessage, setopenUnavailablecategoryMessage] =
        useState("");
    const [userDetails, setUserDetails] = useState<any>();
    const [activeId, setActiveId] = useState(0);
    const [ActiveTrackerType, setActiveTrackerType] = useState<any>(localStorage.getItem("mode") === "personal" ? "personal" : "Default");
    const [showLoaderPage, setShowLoaderPage] = useState(false);
    const [openUnavailablecategory, setopenUnavailablecategory] = useState(false);
    const [ImageFile, setImageFile] = useState(null);
    const [startDay, setStartDay] = useState<any>();
    const [calendar, setCalendar] = useState([]);
    const [endDay, setEndDay] = useState<any>();
    const [unreadNotifications, setUnreadNotifications] = useState([])
    const [notifications, setNotifications] = useState([])
    const [openStartModal, setopenStartModal] = useState(false)
    const [ShowMenu, setShowMenu] = useState(false);
    const [isFirst, setIsFirst] = useState("");
    const [TheDay, setTheDay] = useState(moment());
    const [today, setToday] = useState(moment());
    const [outcomeId, setOutcomeId] = useState<any>();
    const [outcomeIndex, setOutcomeIndex] = useState<any>();
    const [influenceId, setInfluenceId] = useState("");
    const [OpenTrackingEventModal, setOpenTrackingEventModal] = useState(false);
    const [expandedLevelView, setExpandedLevelView] = useState(localStorage.getItem("expandLevelView") === "true")
    const [openHoursModal, setOpenHoursModal] = useState(false);
    const [openYesNoModal, setOpenYesNoModal] = useState(false);
    const [openTimeOfDayModal, setOpenTimeOfDayModal] = useState(false);
    const [displayBorder, setDisplayBorder] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [optionIndex, setOptionIndex] = useState<any>("");
    const [selectedOption, setSelectedOption] = useState<any>();
    const [openTrackingInfluenceModal, setopenTrackingInfluenceModal] =
        useState(false);
    const [item, setItem] = useState<any>();
    const [BlurOn, setBlurOn] = useState(false);
    const [link, setLink] = useState("")
    const [refId, setRefId] = useState("");
    const [openRefQuesModal, setOpenRefQuesModal] = useState(false);
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    useEffect(() => {
        if ((!notifications || !notifications.length) && !alreadyCalled) {
            notificationService.getNotificationList(outcomeState.token)
                .then((res) => {
                    setNotifications(res?.notificationData)
                    setUnreadNotifications(res?.unread)
                    // notificationDispatch(updateNotificationData(res?.notificationData));
                    // notificationDispatch(updateUnreadNotificationData(res?.unread));
                }).catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    // this.setState({
                    //   buttonLoading: false
                    // })
                    // this.openCloseEditGoalModal(false)
                });
        }
    }, [])
    useEffect(() => {
        if (
            userDetails && userDetails?.streakDays !== outcomeState.userDetails?.streakDays
        ) {
            setUserDetails(outcomeState.userDetails);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outcomeState.userDetails]);
    useEffect(() => {
        callservice()
    }, [outcomeState?.isPersonal])
    useEffect(() => {
        getOutcomeList();
        getUserDetails();
        getInfluenceList();
        getReflectiveList();
        getOutcomeSuggestion();
        getInfluenceSuggestion();
        getReflectiveSuggestionList();
    }, [outcomeState?.isPersonal]);
    useEffect(() => {
        if (calendar.length === 0) {
            const current = moment()
            let startDate = moment().startOf('month');
            if (current?.diff(startDate, "day") < 7) {
                startDate = moment().startOf('month').subtract(7 - current?.diff(startDate, "day"), 'day').startOf('day')
            }
            const endOfMonth = moment().clone().endOf('month')
            if (endOfMonth?.diff(moment(), "day") >= 7) {
                setEndDay(moment().clone().endOf('month'));
                setMobileEndDay && setMobileEndDay(moment().clone().endOf('month'))
            } else {
                setMobileEndDay && setMobileEndDay(moment().clone().endOf('month').add(7, 'day'))
                setEndDay(moment().clone().endOf('month').add(7, 'day'));
            }
            setMobileStartDay && setMobileStartDay(startDate)
            setStartDay(startDate);
        }
        enumerateDaysBetweenDates()
        createDate && callservice();
    }, [startDay, endDay]);
    let registeredDate = moment(createDate);
    const enumerateDaysBetweenDates = () => {
        if (startDay && endDay && createDate) {
            var dates = [];
            const currDate = startDay?.clone().isBefore(registeredDate)
                ? registeredDate.clone().subtract(1, "day")
                : startDay?.clone().subtract(1, "day");
            const lastDate = moment(endDay).add(1, "day").startOf('day');

            while (currDate?.add(1, 'days')?.diff(lastDate) < 0) {
                dates.push(currDate?.clone());
            }
            setCalendar([dates]);
            currentDateRef && currentDateRef.current && currentDateRef.current.scrollIntoView()
        }
    };
    const callservice = async (showLoader = true) => {
        try {
            const bodyData = {
                from: moment(startDay).startOf("month").format("MM-DD-YYYY"),
                to: moment(endDay).endOf("month").format("MM-DD-YYYY"),
            };
            if (!outcomeState?.isPersonal) {
                let data = await trackingService.getJourneyList(
                    outcomeState.token,
                    bodyData
                );
                userTypeDispatch(addJourneyAction(data));
                userTypeDispatch(addNotesAction(data));
            } else {
                setShowLoader(showLoader)
                setShowLoaderPage(showLoader);
                let data1 = await trackingService.getJourneyList(
                    outcomeState.token,
                    bodyData
                );
                userTypeDispatch(addJourneyAction(data1));
                userTypeDispatch(addNotesAction(data1));
                let data = await trackingService.getPersonalJourneyList(
                    outcomeState.token,
                    bodyData
                );
                userTypeDispatch(addCategoryJourneyAction(data?.data));
                userTypeDispatch(addNotesJourneyAction(data?.data));
                setShowLoaderPage(showLoader);
                setShowLoader(showLoader)
            }
            setShowLoader(false)
            setShowLoaderPage(false);
        } catch (error) {
            setShowLoader(false)
            setShowLoaderPage(false);
        }
    };
    const getUserDetails = () => {
        const userId = {
            uid: outcomeState?.userId ? outcomeState?.userId : userValues?.uid,
        };
        userService
            .getUserById(userId)
            .then((data: any) => {
                setUserDetails(data?.data);
                data?.data?.imageUrl !== "Not Updated"
                    ? setImageFile(data?.data?.imageUrl)
                    : setImageFile(null);
                localStorage.setItem("userValues", JSON.stringify(data?.data));
                localStorage.setItem("userDate", JSON.stringify(data?.data?.createdAt));
            })
            .catch((error) => {
                console.log("User profile Error");
            });
    };
    const getOutcomeList = () => {
        outcomeService
            .getOutcomeList(outcomeState.token)
            .then((data: OutcomeGetResponse) => {
                userTypeDispatch(addOutcomeAction(data?.data));
            })
            .catch((error) => {
                console.log("Outcome Error");
            });
    };

    const getInfluenceList = () => {
        influenceService
            .getInfluenceList(outcomeState.token)
            .then((data: InfluenceGetResponse) => {
                userTypeDispatch(addInfluenceAction(data?.data));
            })
            .catch((error) => {
                console.log("influence Error");
            });
    };

    const getReflectiveList = () => {
        reflectiveQueService
            .getReflectiveList(outcomeState.token)
            .then((data: RefelectiveGetResponse) => {
                userTypeDispatch(addRefelectiveAction(data?.data));
            })
            .catch((error) => {
                console.log("Ques error");
            });
    };
    const getOutcomeSuggestion = () => {
        outcomeService
            .getOutcomeSuggestion(outcomeState.token)
            .then((res: any) => {
                setOutcomeIdeas(res?.data);
            })
            .catch((error: any) => {
                console.log("Outcome suggestion error", error);
            });
    };

    const getInfluenceSuggestion = () => {
        influenceService
            .getInfluenceSuggestion(outcomeState.token)
            .then((res: any) => {
                setInfluenceIdeas(res?.data);
            })
            .catch((error: any) => {
                console.log("influence suggestion error", error);
            });
    };

    const getReflectiveSuggestionList = () => {
        reflectiveQueService
            .getRefelectiveSuggestion(outcomeState.token)
            .then((res: any) => {
                setReflectiveIdeas(res?.data);
            })
            .catch((error: any) => {
                console.log("Outcome suggestion error", error);
            });
    };
    const prevMonth = () => {

        if (isFirst === "next") {
            setIsFirst("prev");
            setToday(today.subtract(1, "month")); // today date
            setStartDay(today.clone().startOf("month")); // give start of the today date month
            setTheDay(today.clone().startOf("month"))
            setMobileStartDay && setMobileStartDay(today.clone().startOf("month"))
            if (today.clone().endOf("month").isBefore(registeredDate)) {
                setMobileEndDay && setMobileEndDay(registeredDate.clone().endOf("month"))
                setEndDay(registeredDate.clone().endOf("month"));
            } else {
                setMobileEndDay && setMobileEndDay(today.clone().endOf("month"))
                setEndDay(today.clone().endOf("month")); // give end of the today month
            }
        } else {
            setIsFirst("prev");
            setToday(today.subtract(1, "month"));
            setStartDay(today.clone().startOf("month"));
            setTheDay(today.clone().startOf("month"))
            setMobileStartDay && setMobileStartDay(today.clone().startOf("month"))
            // setEndDay(today.clone().endOf("month"));
            if (today.clone().endOf("month").isBefore(registeredDate)) {
                setMobileEndDay && setMobileEndDay(registeredDate.clone().endOf("month"))
                setEndDay(registeredDate.clone().endOf("month"));
            } else {
                setMobileEndDay && setMobileEndDay(today.clone().endOf("month"))
                setEndDay(today.clone().endOf("month")); // give end of the today month
            }
        }
    };

    const nextMonth = () => {
        if (isFirst === "prev") {
            setIsFirst("next");
            setToday(today.clone().add(1, "month"));
            setMobileStartDay && setMobileStartDay(today.clone().add(1, "month").startOf("month"))
            setStartDay(today.clone().add(1, "month").startOf("month"));
            setMobileEndDay && setMobileEndDay(today.clone().add(1, "month").endOf("month"))
            setEndDay(today.clone().add(1, "month").endOf("month"));
            setTheDay(today.clone().add(1, "month").startOf("month"))
        } else {
            setIsFirst("next");
            setToday(today.clone().add(1, "month"));
            setMobileStartDay && setMobileStartDay(today.clone().add(1, "month").startOf("month"))
            setStartDay(today.clone().add(1, "month").startOf("month"));
            setMobileEndDay && setMobileEndDay(today.clone().add(1, "month").endOf("month"))
            setEndDay(today.clone().add(1, "month").endOf("month"));
            setTheDay(today.clone().add(1, "month").startOf("month"))
        }
    };
    const searchBarProps = {
        // make sure all required component's inputs/Props keys&types match
        onChange: (e) => {
            setExpandedLevelView(!expandedLevelView)
            localStorage.setItem("expandLevelView", `${!expandedLevelView}`)
            // setShowDay(!showDay);
            // setCheckedSwitch(e.target.checked)
            // if(!e.target.checked) {
            //   reminderCreate()

            // }
        },
        checked: expandedLevelView,
    };
    const influenceCreate = (inputValue, headerDate, notes = []) => {
        setShowLoader(false)

        setShowLoaderPage(false);
        const outcomeCreateData = {
            date: headerDate,
            influenceId: item?.influenceId,
            answerId: Number(inputValue) === 0 ? null : item?.options[parseInt(inputValue) - 1]?.answerId,
            score: parseInt(inputValue) === 0 ? 0 : item?.options[parseInt(inputValue) - 1].score,
            index: parseInt(inputValue),
            note: notes,
            type: "TYPE2",
        };
        let oldData: any = {}
        if (!outcomeState?.isPersonal) {
            const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
            if (foundOutcome) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
                if (foundDateItemIcon > -1) {
                    oldData = { ...journyList.influence_data[foundDateItemIcon] }
                }
            }
        } else {
            const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
            const foundOutcome = (journeyCategoryList
                || []).findIndex(it => it.influenceIds && it.influenceIds.includes(outcomeCreateData.influenceId));
            if (foundOutcome > -1) {
                if (journeyCategoryList[foundOutcome].alls && journeyCategoryList[foundOutcome].alls.length) {
                    const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(it => it.influenceId === outcomeCreateData.influenceId)
                    if (foundIndex > -1) {
                        if (journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses && journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.length) {
                            const foundDateValue = journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.findIndex(it => it.date === outcomeCreateData.date)
                            if (foundDateValue > -1) {
                                oldData = { ...journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses[foundDateValue] }
                            }
                        }
                    }
                }
            } else {
                const foundOther = (journeyCategoryList || []).findIndex(it => it.name === "Other")
                if (foundOther > -1) {
                    const outcomeFound = journeyCategoryList[foundOther].influences.findIndex(it => it.influenceId === outcomeCreateData.influenceId);
                    if (outcomeFound > -1) {
                        if (journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses && journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.length) {
                            const foundDateValue = journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.findIndex(it => it.date === outcomeCreateData.date)
                            if (foundDateValue > -1) {
                                oldData = { ...journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses[foundDateValue] }
                            }
                        }
                    }
                }
            }
        }
        const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
        if (foundOutcome) {
            const journyList = { ...(outcomeState?.journeyList || {}) } as any
            const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
            if (foundDateItemIcon > -1) {
                journyList.influence_data[foundDateItemIcon] = {
                    ...foundOutcome,
                    ...outcomeCreateData,
                }
            } else {
                journyList.influence_data.push({
                    ...foundOutcome,
                    ...outcomeCreateData,
                } as any)
            }
            userTypeDispatch(addJourneyAction(journyList as any))
            // if (props.callToGetData) {
            //   props?.callService();
            // }
        }
        if (oldData?.note && oldData?.note.length) {
            outcomeCreateData.note = oldData?.note || []
        }
        trackingService
            .influenceCreate(outcomeState.token, outcomeCreateData)
            .then((data) => {
                if (data.showMessage && headerDate === moment().format("MM-DD-YYYY")) {
                    trackingDispatch(setDayCompleteMessage({
                        open: data.showMessage,
                        message: data.message
                    }))
                }
                if (data.dataStreak) {
                    userTypeDispatch(setUserStreak())
                }
                if (data.heartIncreaseFlag) {
                    userTypeDispatch(setUserHeart())
                }
                // setShowSnakbar(true);
                setSnakbarMsg(data?.message);
                // callservice();
                setShowLoaderPage(false);
                setMsgType("success");
                // setInputValue("");
            })
            .catch((error) => {
                setShowSnakbar(true);
                setSnakbarMsg(
                    error?.response?.data?.message
                        ? error?.response?.data?.message
                        : error?.message
                );
                setMsgType("error");
                setShowLoaderPage(false);
            });
    };
    const unitCreate = (inputValue, headerDate) => {
        // if (item?.options.filter((opt) => opt.value == inputValue).length > 0) {
        try {
            setShowLoaderPage(false);
            const outcomeCreateData = {
                influenceId: item?.influenceId,
                score: inputValue,
                note: [],
                answerId: item?.options?.filter((opt) => opt.value == inputValue)?.[0]?.answerId,
                date: headerDate,
                type: "TYPE12",
            };
            let oldData: any = {}
            if (!outcomeState?.isPersonal) {
                const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
                if (foundOutcome) {
                    const journyList = { ...(outcomeState?.journeyList || {}) } as any
                    const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
                    if (foundDateItemIcon > -1) {
                        oldData = { ...journyList.influence_data[foundDateItemIcon] }
                    }
                }
            } else {
                const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
                const foundOutcome = (journeyCategoryList
                    || []).findIndex(it => it.influenceIds && it.influenceIds.includes(outcomeCreateData.influenceId));
                if (foundOutcome > -1) {
                    if (journeyCategoryList[foundOutcome].alls && journeyCategoryList[foundOutcome].alls.length) {
                        const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(it => it.influenceId === outcomeCreateData.influenceId)
                        if (foundIndex > -1) {
                            if (journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses && journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.length) {
                                const foundDateValue = journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses.findIndex(it => it.date === outcomeCreateData.date)
                                if (foundDateValue > -1) {
                                    oldData = { ...journeyCategoryList[foundOutcome].alls[foundIndex].influenceResponses[foundDateValue] }
                                }
                            }
                        }
                    }
                } else {
                    const foundOther = (journeyCategoryList || []).findIndex(it => it.name === "Other")
                    if (foundOther > -1) {
                        const outcomeFound = journeyCategoryList[foundOther].influences.findIndex(it => it.influenceId === outcomeCreateData.influenceId);
                        if (outcomeFound > -1) {
                            if (journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses && journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.length) {
                                const foundDateValue = journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses.findIndex(it => it.date === outcomeCreateData.date)
                                if (foundDateValue > -1) {
                                    oldData = { ...journeyCategoryList[foundOther].influences[outcomeFound].influenceResponses[foundDateValue] }
                                }
                            }
                        }
                    }
                }
            }
            if (oldData?.note && oldData?.note.length) {
                outcomeCreateData.note = oldData?.note || []
            }
            const foundOutcome = (outcomeState?.influenceList || []).find(it => it.influenceId === outcomeCreateData.influenceId);
            if (foundOutcome) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundDateItemIcon = journyList.influence_data.findIndex(it => it.influenceId === outcomeCreateData.influenceId && it?.date === outcomeCreateData.date)
                if (foundDateItemIcon > -1) {
                    journyList.influence_data[foundDateItemIcon] = {
                        ...foundOutcome,
                        ...outcomeCreateData,
                    }
                } else {
                    journyList.influence_data.push({
                        ...foundOutcome,
                        ...outcomeCreateData,
                    } as any)
                }
                userTypeDispatch(addJourneyAction(journyList as any))
                // if (props.callToGetData) {
                //   props?.callService();
                // }
            }
            trackingService
                .influenceCreate(outcomeState.token, outcomeCreateData)
                .then((data) => {
                    // setShowSnakbar(true);
                    setSnakbarMsg(data?.message);
                    // callservice();
                    setShowLoaderPage(false);
                    setMsgType("success");
                    // setInputValue("");
                })
                .catch((error) => {
                    setShowSnakbar(true);
                    setSnakbarMsg(
                        error?.response?.data?.message
                            ? error?.response?.data?.message
                            : error?.message
                    );
                    setMsgType("error");
                    setShowLoaderPage(false);
                });
        } catch (error) {
            console.log("======== error", error);

        }

        // } else {
        //     setShowSnakbar(true);
        //     setMsgType("error");
        //     setSnakbarMsg("Please enter value available on scale");
        // }
    };

    const outcomeCreate = (inputValue, headerDate) => {
        setShowLoaderPage(true);
        const outcomeCreateData = {
            date: headerDate,
            outcomeId: item?.outcomeId,
            answerId: Number(inputValue) === 0 ? null : item?.options[parseInt(inputValue) - 1].answerId,
            score: Number(inputValue) === 0 ? inputValue : item?.options[parseInt(inputValue) - 1].score,
            index: parseInt(inputValue),
            note: [],
        };
        let oldData: any = {}
        if (!outcomeState?.isPersonal) {
            const foundOutcome = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
            if (foundOutcome) {
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                if (foundDateItemIcon > -1) {
                    oldData = { ...journyList.outcome_data[foundDateItemIcon] }
                    journyList.outcome_data[foundDateItemIcon] = {
                        ...foundOutcome,
                        ...outcomeCreateData,
                    }
                } else {
                    journyList.outcome_data.push({
                        ...foundOutcome,
                        ...outcomeCreateData,
                    } as any)
                }
                userTypeDispatch(addJourneyAction(journyList as any))
            }
        } else {
            const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])]
            const foundOutcome = (journeyCategoryList
                || []).findIndex(it => it.outcomeIds && it.outcomeIds.includes(outcomeCreateData.outcomeId));
            if (foundOutcome > -1) {

                if (journeyCategoryList[foundOutcome].alls && journeyCategoryList[foundOutcome].alls.length) {
                    const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId)
                    if (foundIndex > -1) {
                        if (journeyCategoryList[foundOutcome].alls[foundIndex].outcomesResponses && journeyCategoryList[foundOutcome].alls[foundIndex].outcomesResponses.length) {
                            const foundDateValue = journeyCategoryList[foundOutcome].alls[foundIndex].outcomesResponses.findIndex(it => it.date === outcomeCreateData.date)
                            if (foundDateValue > -1) {
                                oldData = { ...journeyCategoryList[foundOutcome].alls[foundIndex].outcomesResponses[foundDateValue] }
                            }
                        }
                    }
                }
                const journyList = { ...(outcomeState?.journeyList || {}) } as any
                const foundOutcomeNew = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                if (foundDateItemIcon > -1) {
                    oldData = { ...journyList.outcome_data[foundDateItemIcon] }
                    journyList.outcome_data[foundDateItemIcon] = {
                        ...foundOutcomeNew,
                        ...outcomeCreateData,
                    }
                } else {
                    journyList.outcome_data.push({
                        ...foundOutcomeNew,
                        ...outcomeCreateData,
                    } as any)
                }
                userTypeDispatch(addJourneyAction(journyList as any))
            } else {
                const foundOther = (journeyCategoryList
                    || []).findIndex(it => it.name === "Other")
                if (foundOther > -1) {
                    const outcomeFound = journeyCategoryList[foundOther].outcomes.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId);
                    if (outcomeFound > -1) {
                        if (journeyCategoryList[foundOther].outcomes[outcomeFound].outcomesResponses && journeyCategoryList[foundOther].outcomes[outcomeFound].outcomesResponses.length) {
                            const foundDateValue = journeyCategoryList[foundOther].outcomes[outcomeFound].outcomesResponses.findIndex(it => it.date === outcomeCreateData.date)
                            if (foundDateValue > -1) {
                                oldData = { ...journeyCategoryList[foundOther].outcomes[outcomeFound].outcomesResponses[foundDateValue] }
                            }
                        }
                    }
                    const journyList = { ...(outcomeState?.journeyList || {}) } as any
                    const foundOutcomeNew = (outcomeState?.outcomeList || []).find(it => it.outcomeId === outcomeCreateData.outcomeId);
                    const foundDateItemIcon = journyList.outcome_data.findIndex(it => it.outcomeId === outcomeCreateData.outcomeId && it?.date === outcomeCreateData.date)
                    if (foundDateItemIcon > -1) {
                        oldData = { ...journyList.outcome_data[foundDateItemIcon] }
                        journyList.outcome_data[foundDateItemIcon] = {
                            ...foundOutcomeNew,
                            ...outcomeCreateData,
                        }
                    } else {
                        journyList.outcome_data.push({
                            ...foundOutcomeNew,
                            ...outcomeCreateData,
                        } as any)
                    }
                    userTypeDispatch(addJourneyAction(journyList as any))
                }
            }
        }
        if (oldData?.note && oldData?.note.length) {
            outcomeCreateData.note = oldData?.note || []
        }
        trackingService
            .outcomeCreate(outcomeState.token, outcomeCreateData)
            .then((data) => {
                if (data.showMessage && headerDate === moment().format("MM-DD-YYYY")) {
                    trackingDispatch(setDayCompleteMessage({
                        open: data.showMessage,
                        message: data.message
                    }))
                }
                if (data.dataStreak) {
                    userTypeDispatch(setUserStreak())
                }
                if (data.heartIncreaseFlag) {
                    userTypeDispatch(setUserHeart())
                }
                setShowSnakbar(true);
                setSnakbarMsg(data?.message);
                // callservice();
                setShowLoaderPage(false);
                setMsgType("success");
            })
            .catch((error) => {
                setShowSnakbar(true);
                setSnakbarMsg(
                    error?.response?.data?.message
                        ? error?.response?.data?.message
                        : error?.message
                );
                setMsgType("error");
                setShowLoaderPage(false);
            });
    };
    const clickCondition = moment(betweenDate).isBetween(
        moment().subtract(8, "year").format("yyyy-MM-DD"),
        // moment().subtract(8, "day").format("yyyy-MM-DD"),
        moment().add(1, "day").format("yyyy-MM-DD")
    );
    const handleCloseSnakbar = () => {
        setShowSnakbar(false);
    };

    return <Box sx={{ display: "flex", overflowX: "hidden", overflowY: 'auto', }} className="hide-scrollbar">
        <SnackBarComp
            showSnakbar={showSnakbar}
            handleCloseSnakbar={handleCloseSnakbar}
            snakbarMsg={snakbarMsg}
            type={msgType ? msgType : "success"}
        />
        <Box sx={{
            padding: "0px 16px 60px",
            width: "100%",
            overflowX: "hidden", overflowY: 'auto',
            height: "100dvh",
            background: "#fff",

        }} className="hide-scrollbar">
            <Box className="mobileHeader" sx={{
                position: 'sticky', top: "calc(0px + env(safe-area-inset-top))", zIndex: 1,
                display: "flex", flexDirection: "column", gap: "16px",
                background: "#fff",
                paddingTop: "16px",
            }}>
                <Box borderBottom={"1px solid var(--color-border)"} display={"flex"} justifyContent={"space-between"} paddingBottom={"16px"}>
                    <CommonTypo size={24} fontWeight={700} lineHeight={28.8} color="var(--color-text-primary)" extraSx={{
                        marginTop: "2px"
                    }}>Hi,  {userDetails?.first_name
                        ? userDetails?.first_name
                        : userValues?.first_name} </CommonTypo>
                    <Box className="mobileMenu" sx={{ display: "flex", gap: "16px", height: "40px" }} alignItems={"center"}>
                        <Box sx={{ display: "flex", gap: "8px" }} alignItems={"center"}>
                            <Box className="mobileMenu" sx={{ display: "flex", gap: "2px" }} alignItems={"center"}>
                                <StrikeIconV2 width="20" height="20" />
                                {Number(userDetails?.streakDays) >= 0 && (
                                    <CommonTypo color="#5E5F5E" size={16} fontWeight={600}>{userDetails?.streakDays}</CommonTypo>
                                )}
                            </Box>
                            <Box className="mobileMenu" sx={{ display: "flex", gap: "2px" }} alignItems={"center"}>
                                <HeartBlankV2 filled size="24" />
                                {Number(userDetails?.hearts) >= 0 && (
                                    <CommonTypo color="#5E5F5E" size={16} fontWeight={600}>{userDetails?.hearts}</CommonTypo>
                                )}
                            </Box>
                        </Box>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }} onClick={() => { setopenStartModal(true) }}>
                            <NotificationMobile notificationAvailable={unreadNotifications.length > 0} />
                        </div>

                        {/* <StyledBadge color="primary" badgeContent={unreadNotifications.length} max={99} >
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }} onClick={() => { setopenStartModal(true) }}>
                                <BellIcon isMobile color={"var(--color-black)"}/>
                            </div>
                        </StyledBadge> */}
                        <Box onClick={() => setShowMenu(!ShowMenu)}>
                            {ShowMenu ? (
                                <Box width="40px"
                                    height="40px"
                                    top="24px"
                                    left="304px"
                                    padding="8px"
                                    gap="8px"
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    borderRadius="12px"
                                    sx={{
                                        background: "var(--color-border)"
                                    }}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.5459 17.9541C19.7572 18.1654 19.876 18.4521 19.876 18.751C19.876 19.0499 19.7572 19.3365 19.5459 19.5479C19.3346 19.7592 19.0479 19.8779 18.749 19.8779C18.4501 19.8779 18.1635 19.7592 17.9521 19.5479L12 13.5938L6.0459 19.546C5.83455 19.7573 5.54791 19.8761 5.24902 19.8761C4.95014 19.8761 4.66349 19.7573 4.45215 19.546C4.2408 19.3346 4.12207 19.048 4.12207 18.7491C4.12207 18.4502 4.2408 18.1636 4.45215 17.9522L10.4062 12L4.45402 6.04598C4.24268 5.83464 4.12395 5.54799 4.12395 5.2491C4.12395 4.95022 4.24268 4.66357 4.45402 4.45223C4.66537 4.24089 4.95201 4.12215 5.2509 4.12215C5.54978 4.12215 5.83643 4.24089 6.04777 4.45223L12 10.4063L17.954 4.45129C18.1654 4.23995 18.452 4.12122 18.7509 4.12122C19.0498 4.12122 19.3364 4.23995 19.5478 4.45129C19.7591 4.66264 19.8778 4.94928 19.8778 5.24817C19.8778 5.54705 19.7591 5.8337 19.5478 6.04504L13.5937 12L19.5459 17.9541Z" fill="#3E4240" />
                                    </svg>

                                </Box>
                            ) : <Box width="40px"
                                height="40px"
                                top="24px"
                                gap="8px"
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                                borderRadius="12px"
                            ><MobileMenuIcon /> </Box>}

                        </Box>
                    </Box>
                </Box>
                <Box display={"flex"} flexDirection={"column"} gap={"8px"} width={"100%"}>
                    <Box display={"flex"} justifyContent={"space-between"} gap={"8px"} width={"100%"} height={"24px"}>
                        <CommonTypo size={18} lineHeight={21.6} color="var(--color-text-primary)" fontWeight={600}>
                            {calendar[0] ? calendar[0][0].format("MMMM") : ''}{calendar && calendar[0] ? calendar[0][0].format("MMMM") !== calendar[0][calendar[0].length - 1].format("MMMM") ? `/${calendar[0][calendar[0].length - 1].format("MMMM")}` : "" : ""}
                        </CommonTypo>
                        <Box display={"flex"} alignItems={"center"}>
                            <Box sx={{
                                cursor: "pointer",
                                height: "24px",
                                width: "24px"
                            }} onClick={prevMonth}>
                                <CommonTypo size={16} color={!moment(userValues?.createdAt).isBefore(
                                    moment(startDay)
                                )
                                    ? "gray"
                                    : "var(--color-text-primary)"}> &lt;</CommonTypo>
                            </Box>
                            <Box sx={{
                                cursor: "pointer",
                                height: "24px",
                                width: "24px"
                            }} onClick={nextMonth}>
                                <CommonTypo size={16} color={"var(--color-text-primary)"}> &gt;</CommonTypo>
                            </Box>
                        </Box>
                    </Box>
                    <Box width={"100%"} sx={{
                        overflowY: "auto",
                        display: "flex",
                    }} className="hide-scrollbar">
                        {calendar.map((month) => (
                            <InsideMonth
                                month={month}
                                TheDay={TheDay}
                                setTheDay={(day) => {
                                    if (moment(day).isAfter(moment().endOf("day"))) {
                                    } else {
                                        setTheDay(day)
                                    }
                                }}
                                currentDateRef={currentDateRef}
                            />
                        ))}

                    </Box>
                </Box>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={"8px"} width={"100%"} marginTop={"16px"}>
                <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} gap={"8px"} width={"100%"}>
                    <div style={{
                        display: 'inline-flex',
                        justifyContent: "center",
                        alignItems: 'center',
                        borderRadius: '50%',
                        cursor: "pointer",
                        height: "32px",
                        width: "32px",
                    }} id={"mobile-add-title"} onClick={() => {
                        setAddOutcomeTracking(true);
                        setStartModal(true);
                        setBlurOn(false)
                    }}>
                        {/* <PlusIconSVG color={"#fff"} size="20" /> */}
                        {/* <img src={PlusIcon} alt="add-category" /> */}
                        <svg width="26" height="26" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30 0.75C24.2149 0.75 18.5597 2.46548 13.7496 5.67951C8.93945 8.89355 5.1904 13.4618 2.97654 18.8065C0.762674 24.1512 0.183426 30.0324 1.31204 35.7064C2.44066 41.3803 5.22645 46.5922 9.31714 50.6829C13.4078 54.7736 18.6197 57.5593 24.2936 58.688C29.9676 59.8166 35.8488 59.2373 41.1935 57.0235C46.5382 54.8096 51.1065 51.0606 54.3205 46.2504C57.5345 41.4403 59.25 35.7851 59.25 30C59.2403 22.2454 56.1555 14.8112 50.6722 9.32781C45.1889 3.84447 37.7546 0.759675 30 0.75ZM41.25 32.25H32.25V41.25C32.25 41.8467 32.013 42.419 31.591 42.841C31.169 43.2629 30.5968 43.5 30 43.5C29.4033 43.5 28.831 43.2629 28.409 42.841C27.9871 42.419 27.75 41.8467 27.75 41.25V32.25H18.75C18.1533 32.25 17.581 32.0129 17.159 31.591C16.7371 31.169 16.5 30.5967 16.5 30C16.5 29.4033 16.7371 28.831 17.159 28.409C17.581 27.9871 18.1533 27.75 18.75 27.75H27.75V18.75C27.75 18.1533 27.9871 17.581 28.409 17.159C28.831 16.7371 29.4033 16.5 30 16.5C30.5968 16.5 31.169 16.7371 31.591 17.159C32.013 17.581 32.25 18.1533 32.25 18.75V27.75H41.25C41.8467 27.75 42.419 27.9871 42.841 28.409C43.263 28.831 43.5 29.4033 43.5 30C43.5 30.5967 43.263 31.169 42.841 31.591C42.419 32.0129 41.8467 32.25 41.25 32.25Z" fill="#ADE888" />
                        </svg>

                    </div>
                    <Box display={"flex"} gap={"8px"} justifyContent={"flex-end"} alignItems={"center"} width={"100%"}>
                        <CommonTypo size={12} lineHeight={14.4} color="var(--color-text-primary)">Expand view</CommonTypo>
                        <IOSSwitch {...searchBarProps} />

                    </Box>
                </Box>

                <TabBox tabs={[
                    {
                        name: "Personal structure"
                    },
                    {
                        name: "Standard structure"
                    }
                ]} isMobile onSelectTab={(it) => {
                    setActiveTrackerType(it.name === "Personal structure" ? "personal" : "Default")
                    userTypeDispatch(isPersonalMode(it.name === "Personal structure" ? true : false))
                    localStorage.setItem("mode", it.name === "Personal structure" ? "personal" : "Default")
                }} activeTab={ActiveTrackerType === "personal" ? "Personal structure" : "Standard structure"} fullWidth />
            </Box>
            {!outcomeState?.isPersonal ? (
                <>
                    <MobileAccordion title="Outcomes" tooltipTitle={"Outcomes refer to the psychological states or tangible results that are influenced by your daily habits and actions. These can include your overall well-being, sense of progress, energy levels, and sense of connection. Outcomes are what you track to see the impact of various influences over time. Think of outcomes as the 'results' of your personal experiments."}>
                        {outcomeState?.outcomeList?.map((item, index) => (
                            <div key={index} onClick={() => setActiveId(index)}>
                                <DetailCard
                                    key={index}
                                    title={item?.name}
                                    item={item}
                                    setItem={setItem}
                                    index={index}
                                    setSnakbarMsg={setSnakbarMsg}
                                    setShowSnakbar={setShowSnakbar}
                                    setMsgType={setMsgType}
                                    outcomeCreate={outcomeCreate}
                                    setOpenTrackingEventModal={setOpenTrackingEventModal}
                                    headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                    setOutcomeId={setOutcomeId}
                                    setDisplayBorder={setDisplayBorder}
                                    optionIndex={optionIndex}
                                    setSelectedOption={setSelectedOption}
                                    type="outcome"
                                    TheDay={TheDay}
                                    callService={callservice}
                                    setOutcomeIndex={setOutcomeIndex}
                                    setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                    setopenUnavailablecategory={setopenUnavailablecategory}
                                    expandedLevelView={expandedLevelView}
                                    setOutcomeValue={setOutcomeValue}
                                    setAddOutcomeTracking={setAddOutcomeTracking}
                                    setStartModal={setStartModal}
                                    trackingDispatch={trackingDispatch}
                                />
                            </div>
                        ))}
                        {OpenTrackingEventModal && (
                            <AddTrackingEventModal
                                setOpenTrackingEventModal={setOpenTrackingEventModal}
                                index={activeId}
                                setOutcomeId={setOutcomeId}
                                getBackgroudColor={setOutcomeId}
                                setSelectedOption={setSelectedOption}
                                selectedOption={selectedOption}
                                outcomeId={outcomeId}
                                item={item}
                                setShowSnakbar={setShowSnakbar}
                                setSnakbarMsg={setSnakbarMsg}
                                setMsgType={setMsgType}
                                setOptionIndex={setOptionIndex}
                                optionIndex={optionIndex}
                                setDisplayBorder={setDisplayBorder}
                                displayBorder={displayBorder}
                                callService={callservice}
                                isEdit={isEdit}
                                setIsEdit={setIsEdit}
                                journeyData={outcomeState?.journeyList?.outcome_data}
                                headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                isMobile={true}
                            />
                        )}
                    </MobileAccordion>
                    <MobileAccordion title="Influences" tooltipTitle={"Influences are the behaviors, activities, and external factors that can affect your Outcomes. This includes anything from the amount of sleep you get, to your exercise routine, to the time you spend with loved ones. By tracking Influences, you identify what factors have the most significant positive or negative impact on your Outcomes."}>
                        {outcomeState?.influenceList?.map((item, index) => (
                            <>
                                <DetailCard
                                    key={index}
                                    title={item?.name}
                                    item={item}
                                    setItem={setItem}
                                    index={index}
                                    setSnakbarMsg={setSnakbarMsg}
                                    setShowSnakbar={setShowSnakbar}
                                    setMsgType={setMsgType}
                                    setInfluenceId={setInfluenceId}
                                    influenceCreate={influenceCreate}
                                    setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                    setopenUnavailablecategory={setopenUnavailablecategory}
                                    unitCreate={unitCreate}
                                    setOpenTrackingEventModal={setopenTrackingInfluenceModal}
                                    headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                    type="influence"
                                    callService={callservice}
                                    setOpenYesNoModal={setOpenYesNoModal}
                                    setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                    setOutcomeIndex={setOutcomeIndex}
                                    setDisplayBorder={setDisplayBorder}
                                    setSelectedOption={setSelectedOption}
                                    setOpenHoursModal={setOpenHoursModal}
                                    expandedLevelView={expandedLevelView}
                                    setInfluenceData={setInfluenceData}
                                    setAddInfluenceTracking={setAddInfluenceTracking}
                                    setStartModalInfluence={setStartModalInfluence}
                                    trackingDispatch={trackingDispatch}
                                />
                                {/* {OpenTrackingEventModal &&
                  outcomeState?.outcomePopup?.renderOutcomePopup(index)} */}
                                {/* UNIT LEVEL MODAL */}
                                {openHoursModal &&
                                    item._id === influenceId &&
                                    item?.type === "TYPE12" &&
                                    item?.flag === "no" && (
                                        <AddHoursModal
                                            setOpenHoursModal={setOpenHoursModal}
                                            item={item}
                                            isEdit={isEdit}
                                            setIsEdit={setIsEdit}
                                            journeyData={
                                                outcomeState?.journeyList?.influence_data
                                            }
                                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                            setShowSnakbar={setShowSnakbar}
                                            setSnakbarMsg={setSnakbarMsg}
                                            setMsgType={setMsgType}
                                            callService={callservice}
                                            setInfluenceId={setInfluenceId}
                                            isMobile={true}
                                        />
                                    )}

                                {/* YES/NO MODAL */}
                                {openYesNoModal &&
                                    item._id === influenceId &&
                                    (item?.type === "TYPE3" ||
                                        (item?.type === "TYPE1" && item?.flag === "yes")) && (
                                        <AddYesNoModal
                                            setOpenYesNoModal={setOpenYesNoModal}
                                            setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                            item={item}
                                            isEdit={isEdit}
                                            setIsEdit={setIsEdit}
                                            journeyData={
                                                outcomeState?.journeyList?.influence_data
                                            }
                                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                            setShowSnakbar={setShowSnakbar}
                                            setSnakbarMsg={setSnakbarMsg}
                                            setMsgType={setMsgType}
                                            callService={callservice}
                                            setInfluenceId={setInfluenceId}
                                            isMobile={true}
                                        />
                                    )}

                                {openTimeOfDayModal &&
                                    item._id === influenceId &&
                                    ((clickCondition && item?.type === "TYPE12") ||
                                        (clickCondition &&
                                            item?.unitValue === "timeofday" &&
                                            item?.metric_type === "NEUTRAL")) && (
                                        <AddTimeOfDay
                                            setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                            item={item}
                                            isEdit={isEdit}
                                            setIsEdit={setIsEdit}
                                            journeyData={
                                                outcomeState?.journeyList?.influence_data
                                            }
                                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                            setShowSnakbar={setShowSnakbar}
                                            setSnakbarMsg={setSnakbarMsg}
                                            setMsgType={setMsgType}
                                            callService={callservice}
                                            setInfluenceId={setInfluenceId}
                                            isMobile={true}
                                        />
                                    )}
                                {openTrackingInfluenceModal && item._id === influenceId && (
                                    <AddTrackingEventInfluenceModal
                                        setOpenTrackingEventModal={
                                            setopenTrackingInfluenceModal
                                        }
                                        index={index}
                                        setOutcomeId={setInfluenceId}
                                        getBackgroudColor={() => console.log("get bg")}
                                        setSelectedOption={setSelectedOption}
                                        selectedOption={selectedOption}
                                        setShowInput={() => console.log("close input")}
                                        influenceId={influenceId}
                                        item={item}
                                        setShowSnakbar={setShowSnakbar}
                                        setSnakbarMsg={setSnakbarMsg}
                                        setMsgType={setMsgType}
                                        setOptionIndex={setOptionIndex}
                                        optionIndex={optionIndex}
                                        setDisplayBorder={setDisplayBorder}
                                        displayBorder={displayBorder}
                                        callService={callservice}
                                        isEdit={isEdit}
                                        setIsEdit={setIsEdit}
                                        journeyData={outcomeState?.journeyList?.outcome_data}
                                        headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                        isMobile={true}
                                    />
                                )}
                            </>
                        ))}
                    </MobileAccordion>
                    <MobileAccordion title="Qualitative Reflection" tooltipTitle={"Reflective Questions are prompts that encourage you to think deeper about your day, your reactions to certain events, and the reasons behind your tracked outcomes and influences. They help integrate a journaling aspect into your tracking, allowing for richer insights and a better understanding of your personal development journey."}>
                        {outcomeState?.reflectiveList?.map((item, index) => (
                            <>
                                <DetailCard
                                    key={index}
                                    title={item?.question}
                                    item={item}
                                    setItem={setItem}
                                    index={activeId}
                                    setSnakbarMsg={setSnakbarMsg}
                                    setShowSnakbar={setShowSnakbar}
                                    setMsgType={setMsgType}
                                    setReflectiveId={setRefId}
                                    outcomeCreate={outcomeCreate}
                                    setOpenTrackingEventModal={setOpenTrackingEventModal}
                                    headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                    type="reflective"
                                    setOpenYesNoModal={setOpenYesNoModal}
                                    setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                    setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                    setopenUnavailablecategory={setopenUnavailablecategory}
                                    setOpenRefQuesModal={setOpenRefQuesModal}
                                    setRefId={setRefId}
                                    setOutcomeIndex={setOutcomeIndex}
                                    expandedLevelView={expandedLevelView}
                                    setQuestionData={setQuestionData}
                                    setAddQuesTracking={setAddQuesTracking}
                                    setStartModalQues={setStartModalQues}
                                    trackingDispatch={trackingDispatch}
                                />
                                {/* QUESTION MODAL */}
                                {openRefQuesModal && item.reflectiveId === refId && (
                                    <AddRefQuesModal
                                        setOpenRefQuesModal={setOpenRefQuesModal}
                                        refId={refId}
                                        setShowSnakbar={setShowSnakbar}
                                        setSnakbarMsg={setSnakbarMsg}
                                        setMsgType={setMsgType}
                                        setRefId={setRefId}
                                        callService={callservice}
                                        isEdit={isEdit}
                                        setIsEdit={setIsEdit}
                                        journeyData={outcomeState?.journeyList?.reflective_data}
                                        headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                        item={item}
                                        isMobile={true}
                                    />
                                )}
                            </>
                        ))}
                    </MobileAccordion>
                </>
            ) : (
                <>
                    {outcomeState?.journeyCategoryList && outcomeState?.journeyCategoryList.length > 0 ? (
                        outcomeState?.journeyCategoryList?.map((cat) => {
                            const isToday = moment(TheDay).format("MM-DD-yyyy") === moment(new Date()).format("MM-DD-yyyy")
                            return (
                                <MobileAccordion title={cat?.name} cat={cat} integrationType={cat?.integrationType} isToday={isToday}>
                                    {cat?.name === "Other" ? (
                                        <>
                                            {cat?.outcomes?.map((item, index) => (
                                                <div onClick={() => setActiveId(index)}>
                                                    <DetailCard
                                                        key={index}
                                                        title={item?.name || item?.question}
                                                        item={item}
                                                        category={cat}
                                                        setItem={setItem}
                                                        index={index}
                                                        setSnakbarMsg={setSnakbarMsg}
                                                        setShowSnakbar={setShowSnakbar}
                                                        setMsgType={setMsgType}
                                                        setReflectiveId={setRefId}
                                                        outcomeCreate={outcomeCreate}
                                                        setOpenTrackingEventModal={
                                                            item?.outcomeId
                                                                ? setOpenTrackingEventModal
                                                                : setopenTrackingInfluenceModal
                                                        }
                                                        headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                                        setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                                        setopenUnavailablecategory={setopenUnavailablecategory}
                                                        type={
                                                            item?.outcomeId
                                                                ? "outcome"
                                                                : item?.influenceId
                                                                    ? "influence"
                                                                    : "reflective"
                                                        }
                                                        setSelectedOption={setSelectedOption}
                                                        setOutcomeId={setOutcomeId}
                                                        setDisplayBorder={setDisplayBorder}
                                                        setOpenYesNoModal={setOpenYesNoModal}
                                                        setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                                        setOpenRefQuesModal={setOpenRefQuesModal}
                                                        setRefId={setRefId}
                                                        setOutcomeIndex={setOutcomeIndex}
                                                        outcomeId={outcomeId}
                                                        influenceId={influenceId}
                                                        setInfluenceId={setInfluenceId}
                                                        setOpenHoursModal={setOpenHoursModal}
                                                        expandedLevelView={expandedLevelView}
                                                        setOutcomeValue={setOutcomeValue}
                                                        setAddOutcomeTracking={setAddOutcomeTracking}
                                                        setStartModal={setStartModal}
                                                        trackingDispatch={trackingDispatch}
                                                    />
                                                </div>
                                            ))}
                                            {cat?.influences?.map((item, index) => (
                                                <div onClick={() => setActiveId(index)}>
                                                    <DetailCard
                                                        key={index}
                                                        title={item?.name || item?.question}
                                                        item={item}
                                                        setItem={setItem}
                                                        category={cat}
                                                        index={index}
                                                        influenceCreate={influenceCreate}
                                                        setSnakbarMsg={setSnakbarMsg}
                                                        setShowSnakbar={setShowSnakbar}
                                                        setMsgType={setMsgType}
                                                        unitCreate={unitCreate}
                                                        setReflectiveId={setRefId}
                                                        setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                                        setopenUnavailablecategory={setopenUnavailablecategory}
                                                        outcomeCreate={outcomeCreate}
                                                        setOpenTrackingEventModal={
                                                            item?.outcomeId
                                                                ? setOpenTrackingEventModal
                                                                : setopenTrackingInfluenceModal
                                                        }
                                                        callService={callservice}
                                                        headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                                        type={
                                                            item?.outcomeId
                                                                ? "outcome"
                                                                : item?.influenceId
                                                                    ? "influence"
                                                                    : "reflective"
                                                        }
                                                        setCategoryId={setCategoryId}
                                                        setSelectedOption={setSelectedOption}
                                                        setOutcomeId={setOutcomeId}
                                                        setDisplayBorder={setDisplayBorder}
                                                        setOpenYesNoModal={setOpenYesNoModal}
                                                        setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                                        setOpenRefQuesModal={setOpenRefQuesModal}
                                                        setRefId={setRefId}
                                                        setOutcomeIndex={setOutcomeIndex}
                                                        outcomeId={outcomeId}
                                                        influenceId={influenceId}
                                                        setInfluenceId={setInfluenceId}
                                                        setOpenHoursModal={setOpenHoursModal}
                                                        expandedLevelView={expandedLevelView}
                                                        setInfluenceData={setInfluenceData}
                                                        setAddInfluenceTracking={setAddInfluenceTracking}
                                                        setStartModalInfluence={setStartModalInfluence}
                                                        trackingDispatch={trackingDispatch}
                                                    />
                                                </div>
                                            ))}
                                            {cat?.reflectives?.map((item, index) => (
                                                <div onClick={() => setActiveId(index)}>
                                                    <DetailCard
                                                        key={index}
                                                        title={item?.name || item?.question}
                                                        item={item}
                                                        category={cat}
                                                        setItem={setItem}
                                                        index={index}
                                                        setSnakbarMsg={setSnakbarMsg}
                                                        setShowSnakbar={setShowSnakbar}
                                                        setMsgType={setMsgType}
                                                        setReflectiveId={setRefId}
                                                        outcomeCreate={outcomeCreate}
                                                        setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                                        setopenUnavailablecategory={setopenUnavailablecategory}
                                                        setOpenTrackingEventModal={
                                                            item?.outcomeId
                                                                ? setOpenTrackingEventModal
                                                                : setopenTrackingInfluenceModal
                                                        }
                                                        headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                                        type={
                                                            item?.outcomeId
                                                                ? "outcome"
                                                                : item?.influenceId
                                                                    ? "influence"
                                                                    : "reflective"
                                                        }
                                                        setSelectedOption={setSelectedOption}
                                                        setOutcomeId={setOutcomeId}
                                                        setDisplayBorder={setDisplayBorder}
                                                        setOpenYesNoModal={setOpenYesNoModal}
                                                        setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                                        setOpenRefQuesModal={setOpenRefQuesModal}
                                                        setRefId={setRefId}
                                                        setOutcomeIndex={setOutcomeIndex}
                                                        outcomeId={outcomeId}
                                                        influenceId={influenceId}
                                                        setInfluenceId={setInfluenceId}
                                                        setOpenHoursModal={setOpenHoursModal}
                                                        expandedLevelView={expandedLevelView}
                                                        setQuestionData={setQuestionData}
                                                        setAddQuesTracking={setAddQuesTracking}
                                                        setStartModalQues={setStartModalQues}
                                                        trackingDispatch={trackingDispatch}
                                                    />
                                                </div>
                                            ))}
                                        </>
                                    ) : ((cat?.integrationType !== "GENERAL" && !isToday) || cat?.integrationType === "GENERAL") && (
                                        cat?.alls?.map((item, index) => (
                                            <div onClick={() => setActiveId(index)}>
                                                <DetailCard
                                                    key={index}
                                                    title={item?.name || item?.question}
                                                    item={item}
                                                    setItem={setItem}
                                                    index={index}
                                                    setSnakbarMsg={setSnakbarMsg}
                                                    setShowSnakbar={setShowSnakbar}
                                                    setMsgType={setMsgType}
                                                    setReflectiveId={setRefId}
                                                    outcomeCreate={outcomeCreate}
                                                    unitCreate={unitCreate}
                                                    setCategoryId={setCategoryId}
                                                    category={cat}
                                                    setopenUnavailablecategoryMessage={setopenUnavailablecategoryMessage}
                                                    setopenUnavailablecategory={setopenUnavailablecategory}
                                                    setOpenTrackingEventModal={
                                                        item?.outcomeId
                                                            ? setOpenTrackingEventModal
                                                            : setopenTrackingInfluenceModal
                                                    }
                                                    headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                                    type={
                                                        item?.outcomeId
                                                            ? "outcome"
                                                            : item?.influenceId
                                                                ? "influence"
                                                                : "reflective"
                                                    }
                                                    callService={callservice}
                                                    influenceCreate={influenceCreate}
                                                    setSelectedOption={setSelectedOption}
                                                    setOutcomeId={setOutcomeId}
                                                    setDisplayBorder={setDisplayBorder}
                                                    setOpenYesNoModal={setOpenYesNoModal}
                                                    setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                                    setOpenRefQuesModal={setOpenRefQuesModal}
                                                    setRefId={setRefId}
                                                    setOutcomeIndex={setOutcomeIndex}
                                                    outcomeId={outcomeId}
                                                    influenceId={influenceId}
                                                    setInfluenceId={setInfluenceId}
                                                    setOpenHoursModal={setOpenHoursModal}
                                                    expandedLevelView={expandedLevelView}
                                                    setOutcomeValue={setOutcomeValue}
                                                    setAddOutcomeTracking={setAddOutcomeTracking}
                                                    setStartModal={setStartModal}
                                                    setInfluenceData={setInfluenceData}
                                                    setAddInfluenceTracking={setAddInfluenceTracking}
                                                    setStartModalInfluence={setStartModalInfluence}
                                                    setQuestionData={setQuestionData}
                                                    setAddQuesTracking={setAddQuesTracking}
                                                    setStartModalQues={setStartModalQues}
                                                    trackingDispatch={trackingDispatch}
                                                />
                                            </div>
                                        ))
                                    )}
                                </MobileAccordion>
                            );
                        })
                    ) : (
                        <div
                            style={{
                                marginTop: "50px",
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <h4 style={{ color: "#3e4240" }}>
                                {!showLoaderPage && "You don’t have personal data. Start adding it"}
                            </h4>
                        </div>
                    )}
                    {OpenTrackingEventModal && (
                        <AddTrackingEventModal
                            setOpenTrackingEventModal={setOpenTrackingEventModal}
                            index={outcomeIndex}
                            setOutcomeId={setOutcomeId}
                            getBackgroudColor={setOutcomeId}
                            setSelectedOption={setSelectedOption}
                            selectedOption={selectedOption}
                            outcomeId={outcomeId}
                            item={item}
                            setShowSnakbar={setShowSnakbar}
                            setSnakbarMsg={setSnakbarMsg}
                            setMsgType={setMsgType}
                            setOptionIndex={setOptionIndex}
                            optionIndex={optionIndex}
                            setDisplayBorder={setDisplayBorder}
                            displayBorder={displayBorder}
                            callService={callservice}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            journeyData={outcomeState?.journeyList?.outcome_data}
                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                            callToGetData={true}
                            isMobile={true}
                        />
                    )}
                    {openTrackingInfluenceModal && item._id === influenceId && (
                        <AddTrackingEventInfluenceModal
                            setOpenTrackingEventModal={setopenTrackingInfluenceModal}
                            index={outcomeIndex}
                            setOutcomeId={setInfluenceId}
                            getBackgroudColor={() => console.log("get bg")}
                            setSelectedOption={setSelectedOption}
                            selectedOption={selectedOption}
                            setShowInput={() => console.log("close input")}
                            influenceId={influenceId}
                            item={item}
                            setShowSnakbar={setShowSnakbar}
                            setSnakbarMsg={setSnakbarMsg}
                            setMsgType={setMsgType}
                            setOptionIndex={setOptionIndex}
                            optionIndex={optionIndex}
                            setDisplayBorder={setDisplayBorder}
                            displayBorder={displayBorder}
                            callService={callservice}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            journeyData={outcomeState?.journeyList?.influence_data}
                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                            callToGetData={true}
                            isMobile={true}
                        />
                    )}
                    {openHoursModal && (
                        <AddHoursModal
                            setOpenHoursModal={setOpenHoursModal}
                            item={item}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            journeyData={outcomeState?.journeyList?.influence_data}
                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                            setShowSnakbar={setShowSnakbar}
                            setSnakbarMsg={setSnakbarMsg}
                            setMsgType={setMsgType}
                            callService={callservice}
                            setInfluenceId={setInfluenceId}
                            callToGetData={true}
                            isMobile={true}
                        />
                    )}
                    {openYesNoModal && (
                        // (item?.type === "TYPE3" ||
                        //   (item?.type === "TYPE1" && item?.flag === "yes")) && (
                        <AddYesNoModal
                            setOpenYesNoModal={setOpenYesNoModal}
                            item={item}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            journeyData={outcomeState?.journeyList?.influence_data}
                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                            setShowSnakbar={setShowSnakbar}
                            setSnakbarMsg={setSnakbarMsg}
                            setMsgType={setMsgType}
                            callService={callservice}
                            setInfluenceId={setInfluenceId}
                            callToGetData={true}
                            isMobile={true}

                        />
                    )}
                    {openTimeOfDayModal &&
                        item._id === influenceId &&
                        ((clickCondition && item?.type === "TYPE12") ||
                            (clickCondition &&
                                item?.unitValue === "timeofday" &&
                                item?.metric_type === "NEUTRAL")) && (
                            <AddTimeOfDay
                                setOpenTimeOfDayModal={setOpenTimeOfDayModal}
                                item={item}
                                isEdit={isEdit}
                                setIsEdit={setIsEdit}
                                journeyData={outcomeState?.journeyList?.influence_data}
                                headerDate={moment(TheDay).format("MM-DD-yyyy")}
                                setShowSnakbar={setShowSnakbar}
                                setSnakbarMsg={setSnakbarMsg}
                                setMsgType={setMsgType}
                                callService={callservice}
                                setInfluenceId={setInfluenceId}
                                callToGetData={true}
                                isMobile={true}
                                categoryId={categoryId}
                            />
                        )}
                    {openRefQuesModal && item.reflectiveId === refId && (
                        <AddRefQuesModal
                            setOpenRefQuesModal={setOpenRefQuesModal}
                            refId={refId}
                            setShowSnakbar={setShowSnakbar}
                            setSnakbarMsg={setSnakbarMsg}
                            setMsgType={setMsgType}
                            setRefId={setRefId}
                            callService={callservice}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            journeyData={outcomeState?.journeyList?.influence_data}
                            headerDate={moment(TheDay).format("MM-DD-yyyy")}
                            item={item}
                            callToGetData={true}
                            isMobile={true}

                        />
                    )}
                </>
            )}
        </Box>
        {BlurOn && (
            <div
                style={{
                    position: "fixed",
                    width: "100%",
                    height: "100%",
                    background: "rgba( 255, 255, 255, 0.25 )",
                    top: "0",
                    left: "0",
                    backdropFilter: "blur(5px)",
                    zIndex: 2
                }}
            >
                <div
                    style={{
                        position: "fixed",
                        color: "black",
                        bottom: "12%",
                        right: "8%",
                        textAlign: "right",
                    }}
                >
                    <p
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            let days = 0
                            const createDate = outcomeState.userDetails.createdAt
                            const diff = moment().diff(moment(createDate), 'days')
                            if (diff !== 0 && diff < 30) {
                                days = 30 - diff
                            } else if (diff === 0) {
                                days = 30 - diff
                            }
                            if (days > 0 && outcomeState?.outcomeList && outcomeState?.outcomeList?.length >= 5) {
                                setLimitReachPopupVisible(true)
                                setLimitReachPopuptype('outcome')
                            } else {
                                setAddOutcomeTracking(true);
                                setStartModal(true);
                                setBlurOn(false)
                            }

                        }}
                    >
                        Add outcome
                    </p>
                    <p
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            let days = 0
                            const createDate = outcomeState.userDetails.createdAt
                            const diff = moment().diff(moment(createDate), 'days')
                            if (diff !== 0 && diff < 30) {
                                days = 30 - diff
                            } else if (diff === 0) {
                                days = 30 - diff
                            }
                            if (days > 0 && outcomeState?.influenceList && outcomeState?.influenceList?.length >= 10) {
                                setLimitReachPopupVisible(true)
                                setLimitReachPopuptype('influence')
                            } else {
                                setAddInfluenceTracking(true);
                                setStartModalInfluence(true);
                                setBlurOn(false)
                            }

                        }}
                    >
                        Add influence
                    </p>
                    <p
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            let days = 0
                            const createDate = outcomeState.userDetails.createdAt
                            const diff = moment().diff(moment(createDate), 'days')
                            if (diff !== 0 && diff < 30) {
                                days = 30 - diff
                            } else if (diff === 0) {
                                days = 30 - diff
                            }
                            if (days > 0 && outcomeState?.reflectiveList && outcomeState?.reflectiveList?.length >= 3) {
                                setLimitReachPopupVisible(true)
                                setLimitReachPopuptype('question')
                            } else {
                                setAddQuesTracking(true);
                                setStartModalQues(true);
                                setBlurOn(false)

                            }

                        }}
                    >
                        Add reflective questions
                    </p>
                </div>
                <div
                    style={{
                        position: "fixed",
                        background: "var(--color-new-main)",
                        color: "#fff",
                        bottom: "6%",
                        // boxShadow: "1px 2px 5px grey",
                        right: "6%",
                        padding: "8px 10px 8px 8px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        transform: "rotate(45deg)",
                    }}
                    onClick={() => setBlurOn(false)}
                >
                    <PlusIconSVG color="#fff" />
                </div>
            </div>
        )}
        {openUnavailablecategory && (
            <UnavailableCategoryV2
                // open={openUnavailablecategory}
                openUnavailablecategoryMessage={openUnavailablecategoryMessage}
                setopenUnavailablecategory={setopenUnavailablecategory}
                setLink={setLink}
                link={link}
            />)}
        <HeaderPopoverMobile openStartModal={openStartModal} setOpenNOtificationModal={() => {
            setopenStartModal(false)
        }} notifications={notifications} setNotifications={setNotifications}
            unreadNotifications={unreadNotifications} setUnreadNotifications={setUnreadNotifications} />
        {Notification}
        {ShowMenu && <ClickAwayListener onClickAway={() => setShowMenu(!ShowMenu)}>
            <Box
                position={"fixed"}
                display={"flex"}
                zIndex={999}
                sx={{
                    background: "rgba(0, 0, 0, 0.4)",
                }}
                height={"100vh"}
                width={"100vw"}
                onClick={() => setShowMenu(!ShowMenu)}

            >
                <Box width="40px"
                    height="40px"
                    padding="8px"
                    gap="8px"
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    borderRadius="12px"
                    sx={{
                        background: "var(--color-border)"
                    }}
                    position={"absolute"}
                    zIndex={999}
                    top={"16px"}
                    right={"16px"}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.5459 17.9541C19.7572 18.1654 19.876 18.4521 19.876 18.751C19.876 19.0499 19.7572 19.3365 19.5459 19.5479C19.3346 19.7592 19.0479 19.8779 18.749 19.8779C18.4501 19.8779 18.1635 19.7592 17.9521 19.5479L12 13.5938L6.0459 19.546C5.83455 19.7573 5.54791 19.8761 5.24902 19.8761C4.95014 19.8761 4.66349 19.7573 4.45215 19.546C4.2408 19.3346 4.12207 19.048 4.12207 18.7491C4.12207 18.4502 4.2408 18.1636 4.45215 17.9522L10.4062 12L4.45402 6.04598C4.24268 5.83464 4.12395 5.54799 4.12395 5.2491C4.12395 4.95022 4.24268 4.66357 4.45402 4.45223C4.66537 4.24089 4.95201 4.12215 5.2509 4.12215C5.54978 4.12215 5.83643 4.24089 6.04777 4.45223L12 10.4063L17.954 4.45129C18.1654 4.23995 18.452 4.12122 18.7509 4.12122C19.0498 4.12122 19.3364 4.23995 19.5478 4.45129C19.7591 4.66264 19.8778 4.94928 19.8778 5.24817C19.8778 5.54705 19.7591 5.8337 19.5478 6.04504L13.5937 12L19.5459 17.9541Z" fill="#3E4240" />
                    </svg>

                </Box>
                <Box
                    border={"1px solid #D8D8D8"}
                    sx={{
                        background: "var(--color-border)",
                    }}
                    position={"absolute"}
                    display={"flex"}
                    zIndex={999}
                    top={"60px"}
                    right={"16px"}
                    flexDirection={"column"}
                    borderRadius={"12px"}
                    height={"220px"}
                    width={"168px"}
                    overflow={"hidden"}
                >
                    <MenuButton icon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1633 4.33677L15.6633 1.83677C15.5762 1.74937 15.4727 1.68003 15.3587 1.63271C15.2448 1.58539 15.1226 1.56104 14.9992 1.56104C14.8758 1.56104 14.7537 1.58539 14.6397 1.63271C14.5257 1.68003 14.4223 1.74937 14.3352 1.83677L6.83516 9.33677C6.65996 9.513 6.56189 9.75156 6.5625 10.0001V12.5001C6.5625 12.7487 6.66127 12.9872 6.83709 13.163C7.0129 13.3388 7.25136 13.4376 7.5 13.4376H10C10.1231 13.4377 10.2451 13.4135 10.3589 13.3664C10.4727 13.3194 10.5762 13.2504 10.6633 13.1633L18.1633 5.66334C18.2504 5.57627 18.3196 5.47287 18.3668 5.35906C18.414 5.24525 18.4382 5.12326 18.4382 5.00006C18.4382 4.87685 18.414 4.75486 18.3668 4.64105C18.3196 4.52724 18.2504 4.42384 18.1633 4.33677ZM15 3.82818L16.1719 5.00006L15.3125 5.85943L14.1406 4.68756L15 3.82818ZM9.60937 11.5626H8.4375V10.3907L12.8125 6.01568L13.9844 7.18756L9.60937 11.5626ZM17.8125 10.9821V16.2501C17.8125 16.6645 17.6479 17.0619 17.3549 17.3549C17.0618 17.6479 16.6644 17.8126 16.25 17.8126H3.75C3.3356 17.8126 2.93817 17.6479 2.64515 17.3549C2.35212 17.0619 2.1875 16.6645 2.1875 16.2501V3.75006C2.1875 3.33565 2.35212 2.93823 2.64515 2.6452C2.93817 2.35218 3.3356 2.18756 3.75 2.18756H9.01797C9.26661 2.18756 9.50507 2.28633 9.68088 2.46214C9.8567 2.63796 9.95547 2.87642 9.95547 3.12506C9.95547 3.3737 9.8567 3.61215 9.68088 3.78797C9.50507 3.96378 9.26661 4.06256 9.01797 4.06256H4.0625V15.9376H15.9375V10.9821C15.9375 10.7334 16.0363 10.495 16.2121 10.3192C16.3879 10.1434 16.6264 10.0446 16.875 10.0446C17.1236 10.0446 17.3621 10.1434 17.5379 10.3192C17.7137 10.495 17.8125 10.7334 17.8125 10.9821Z" fill="#656565" />
                    </svg>} title={"Tracking"} active onClick={() => {
                        setShowMenu(!ShowMenu)
                    }} />
                    <MenuButton icon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5 15.3125H17.1875V3.125C17.1875 2.87636 17.0887 2.6379 16.9129 2.46209C16.7371 2.28627 16.4986 2.1875 16.25 2.1875H11.875C11.6264 2.1875 11.3879 2.28627 11.2121 2.46209C11.0363 2.6379 10.9375 2.87636 10.9375 3.125V5.9375H7.5C7.25136 5.9375 7.0129 6.03627 6.83709 6.21209C6.66127 6.3879 6.5625 6.62636 6.5625 6.875V9.6875H3.75C3.50136 9.6875 3.2629 9.78627 3.08709 9.96209C2.91127 10.1379 2.8125 10.3764 2.8125 10.625V15.3125H2.5C2.25136 15.3125 2.0129 15.4113 1.83709 15.5871C1.66127 15.7629 1.5625 16.0014 1.5625 16.25C1.5625 16.4986 1.66127 16.7371 1.83709 16.9129C2.0129 17.0887 2.25136 17.1875 2.5 17.1875H17.5C17.7486 17.1875 17.9871 17.0887 18.1629 16.9129C18.3387 16.7371 18.4375 16.4986 18.4375 16.25C18.4375 16.0014 18.3387 15.7629 18.1629 15.5871C17.9871 15.4113 17.7486 15.3125 17.5 15.3125ZM12.8125 4.0625H15.3125V15.3125H12.8125V4.0625ZM8.4375 7.8125H10.9375V15.3125H8.4375V7.8125ZM4.6875 11.5625H6.5625V15.3125H4.6875V11.5625Z" fill="#656565" />
                    </svg>} title={"Progress"} onClick={() => {
                        setShowMenu(!ShowMenu)
                        setLink(`${window.location.origin}/insight-progress`)
                        setopenUnavailablecategoryMessage("To view your progress, please access the app on your desktop browser at")
                        setopenUnavailablecategory(true)
                    }} />
                    <MenuButton icon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.2273 15.4641C17.5485 15.048 17.7466 14.5502 17.7992 14.0272C17.8518 13.5043 17.7568 12.977 17.525 12.5053C17.2931 12.0336 16.9338 11.6363 16.4876 11.3584C16.0415 11.0805 15.5264 10.9333 15.0008 10.9333C14.4752 10.9333 13.9601 11.0805 13.5139 11.3584C13.0678 11.6363 12.7084 12.0336 12.4766 12.5053C12.2448 12.977 12.1498 13.5043 12.2024 14.0272C12.255 14.5502 12.4531 15.048 12.7742 15.4641C12.1986 15.9208 11.7854 16.5509 11.5961 17.2609C11.5325 17.5012 11.5668 17.7569 11.6917 17.9718C11.8165 18.1867 12.0215 18.3432 12.2617 18.407C12.3395 18.4276 12.4196 18.4378 12.5 18.4375C12.7066 18.4374 12.9074 18.369 13.0712 18.2429C13.2349 18.1169 13.3524 17.9403 13.4055 17.7406C13.5938 17.0469 14.2461 16.5625 15 16.5625C15.7539 16.5625 16.4062 17.0469 16.5938 17.7406C16.6609 17.9773 16.8183 18.178 17.0321 18.2997C17.246 18.4213 17.499 18.454 17.7367 18.3907C17.9744 18.3275 18.1777 18.1734 18.3028 17.9616C18.4279 17.7498 18.4648 17.4973 18.4055 17.2586C18.2159 16.5493 17.8028 15.92 17.2273 15.4641ZM15 12.8125C15.1854 12.8125 15.3667 12.8675 15.5208 12.9705C15.675 13.0735 15.7952 13.2199 15.8661 13.3912C15.9371 13.5625 15.9557 13.751 15.9195 13.9329C15.8833 14.1148 15.794 14.2818 15.6629 14.4129C15.5318 14.544 15.3648 14.6333 15.1829 14.6695C15.001 14.7057 14.8125 14.6871 14.6412 14.6161C14.4699 14.5452 14.3235 14.425 14.2205 14.2708C14.1175 14.1167 14.0625 13.9354 14.0625 13.75C14.0625 13.5014 14.1613 13.2629 14.3371 13.0871C14.5129 12.9113 14.7514 12.8125 15 12.8125ZM16.875 5.3125H10.4211L8.38984 3.02422C8.24295 2.85903 8.06268 2.72689 7.86094 2.63652C7.6592 2.54615 7.44059 2.49962 7.21953 2.5H3.125C2.7106 2.5 2.31317 2.66462 2.02015 2.95765C1.72712 3.25067 1.5625 3.6481 1.5625 4.0625V15.6727C1.56291 16.0742 1.72254 16.4591 2.00637 16.7431C2.2902 17.0271 2.67506 17.1869 3.07656 17.1875H8.79375C9.04239 17.1875 9.28085 17.0887 9.45666 16.9129C9.63248 16.7371 9.73125 16.4986 9.73125 16.25C9.73125 16.0014 9.63248 15.7629 9.45666 15.5871C9.28085 15.4113 9.04239 15.3125 8.79375 15.3125H3.4375V7.1875H16.5625V8.4375C16.5625 8.68614 16.6613 8.9246 16.8371 9.10042C17.0129 9.27623 17.2514 9.375 17.5 9.375C17.7486 9.375 17.9871 9.27623 18.1629 9.10042C18.3387 8.9246 18.4375 8.68614 18.4375 8.4375V6.875C18.4375 6.4606 18.2729 6.06317 17.9799 5.77015C17.6868 5.47712 17.2894 5.3125 16.875 5.3125ZM3.4375 5.3125V4.375H7.07891L7.9125 5.3125H3.4375Z" fill="#656565" />
                    </svg>} title={"Personal structure"} onClick={() => {
                        setShowMenu(!ShowMenu)
                        setLink(`${window.location.origin}/add-category`)
                        setopenUnavailablecategoryMessage("To set up personal structure, please access the app on your desktop browser. ")
                        setopenUnavailablecategory(true)
                    }} />
                    <MenuButton icon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.788 8.08746L12.538 1.83746C12.4069 1.70624 12.2399 1.61685 12.058 1.58059C11.8761 1.54433 11.6876 1.56283 11.5162 1.63376C11.3448 1.70468 11.1984 1.82483 11.0953 1.97902C10.9922 2.1332 10.9372 2.3145 10.9372 2.49996V5.37027C8.9247 5.61402 6.74501 6.61168 4.94111 8.14136C2.66298 10.0742 1.24423 12.5703 0.945795 15.1726C0.915562 15.4338 0.968432 15.6978 1.09689 15.9272C1.22534 16.1565 1.42284 16.3396 1.66131 16.4502C1.89977 16.5609 2.16705 16.5936 2.42514 16.5436C2.68324 16.4936 2.91901 16.3635 3.09892 16.1718C3.91611 15.3015 6.77079 12.5984 10.9372 12.2328V15C10.9374 15.1853 10.9924 15.3664 11.0955 15.5204C11.1985 15.6744 11.3448 15.7944 11.516 15.8653C11.6873 15.9362 11.8756 15.9548 12.0574 15.9187C12.2391 15.8826 12.4061 15.7934 12.5372 15.6625L18.7872 9.41246C18.9629 9.23678 19.0616 8.99856 19.0618 8.75012C19.0619 8.50168 18.9634 8.26334 18.788 8.08746ZM12.8122 12.7343V11.25C12.8122 11.0013 12.7134 10.7629 12.5376 10.587C12.3618 10.4112 12.1233 10.3125 11.8747 10.3125C8.04658 10.3125 5.11142 11.9968 3.29736 13.4461C3.85439 12.0273 4.83095 10.6945 6.15439 9.57183C7.91376 8.07886 10.052 7.18746 11.8747 7.18746C12.1233 7.18746 12.3618 7.08868 12.5376 6.91287C12.7134 6.73705 12.8122 6.4986 12.8122 6.24996V4.76558L16.7966 8.74996L12.8122 12.7343Z" fill="#656565" />
                    </svg>} title={"Social reports"} onClick={() => {
                        setShowMenu(!ShowMenu)
                        setopenUnavailablecategoryMessage("To share your reports, please access the app on your desktop browser at")
                        setopenUnavailablecategory(true)
                    }} />
                    <MenuButton icon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.6875 16.875C9.6875 17.1236 9.58873 17.3621 9.41291 17.5379C9.2371 17.7137 8.99864 17.8125 8.75 17.8125H3.75C3.50136 17.8125 3.2629 17.7137 3.08709 17.5379C2.91127 17.3621 2.8125 17.1236 2.8125 16.875V3.125C2.8125 2.87636 2.91127 2.6379 3.08709 2.46209C3.2629 2.28627 3.50136 2.1875 3.75 2.1875H8.75C8.99864 2.1875 9.2371 2.28627 9.41291 2.46209C9.58873 2.6379 9.6875 2.87636 9.6875 3.125C9.6875 3.37364 9.58873 3.6121 9.41291 3.78791C9.2371 3.96373 8.99864 4.0625 8.75 4.0625H4.6875V15.9375H8.75C8.99864 15.9375 9.2371 16.0363 9.41291 16.2121C9.58873 16.3879 9.6875 16.6264 9.6875 16.875ZM18.1633 9.33672L15.0383 6.21172C14.8622 6.0356 14.6233 5.93665 14.3742 5.93665C14.1251 5.93665 13.8863 6.0356 13.7102 6.21172C13.534 6.38784 13.4351 6.62671 13.4351 6.87578C13.4351 7.12485 13.534 7.36372 13.7102 7.53984L15.2344 9.0625H8.75C8.50136 9.0625 8.2629 9.16127 8.08709 9.33709C7.91127 9.5129 7.8125 9.75136 7.8125 10C7.8125 10.2486 7.91127 10.4871 8.08709 10.6629C8.2629 10.8387 8.50136 10.9375 8.75 10.9375H15.2344L13.7094 12.4617C13.5333 12.6378 13.4343 12.8767 13.4343 13.1258C13.4343 13.3749 13.5333 13.6137 13.7094 13.7898C13.8855 13.966 14.1244 14.0649 14.3734 14.0649C14.6225 14.0649 14.8614 13.966 15.0375 13.7898L18.1625 10.6648C18.2499 10.5778 18.3194 10.4743 18.3667 10.3604C18.4141 10.2465 18.4386 10.1243 18.4386 10.0009C18.4387 9.87755 18.4144 9.75537 18.3672 9.64138C18.3199 9.5274 18.2506 9.42387 18.1633 9.33672Z" fill="#656565" />
                    </svg>} title={"Logout"} onClick={() => {
                        localStorage.removeItem("userDetails");
                        localStorage.removeItem("userValues");
                        localStorage.removeItem("userId");
                        localStorage.removeItem("userDate");
                        localStorage.removeItem("trackQuote");
                        localStorage.removeItem("categoryCount");
                        localStorage.removeItem("menuExpandableIds")
                        localStorage.removeItem("menuExpandIds")
                        userTypeDispatch(addCategoryJourneyAction([]));
                        userTypeDispatch(addNotesJourneyAction([]));
                        userTypeDispatch(addOutcomeAction([]));
                        userTypeDispatch(addInfluenceAction([]));
                        userTypeDispatch(addRefelectiveAction([]));
                        userTypeDispatch(addJourneyAction([] as any));
                        userTypeDispatch(addNotesAction([] as any));
                        userTypeDispatch(addCategoryExpandAction([] as any));
                        userTypeDispatch(isPersonalMode(false))
                        trackingDispatch(setTrackingState({
                            calendar: [],
                            isLastAlreadyLoaded: false,
                            showLoader: false
                        }))
                        navigate("/login")
                    }} />
                </Box>
            </Box>

        </ClickAwayListener>}
    </Box>
}

export default MobileScreen

const MenuButton = ({
    icon, title, active = false,
    onClick = () => { }
}) => {
    return <Box borderBottom={"1px"} padding={"12px"} display={"flex"} alignItems={"center"} sx={{
        background: active ? "var(--white-background)" : "var(--color-border)"
    }} gap={"8px"} height={"44px"} onClick={onClick}>
        {icon}
        <CommonTypo size={12} lineHeight={12} color="var(--color-text-primary)">{title}</CommonTypo>
    </Box>
}

const InsideMonth = ({ month, TheDay, setTheDay, currentDateRef }) => {
    const classes = useStyles();
    return (
        <div style={{ display: "flex", gap: "3px" }}>
            {month.map((day) => {
                return (
                    <div
                        className={`${moment().isSame(day, "day")
                            ? clsx(classes.headerBlocks, classes.background)
                            : classes.headerBlocks
                            }`}
                        style={
                            moment(TheDay).isSame(day, "day") || moment().isSame(day, "day")
                                ? { border: "2px solid var(--color-new-main)", borderRadius: "8px" }
                                : { border: "2px solid transparent", }
                        }
                        ref={moment(TheDay).isSame(day, "day") ? currentDateRef : null}
                        onClick={() => {
                            setTheDay(day)
                        }}
                    >
                        <CommonTypo size={10} lineHeight={10} color="var(--color-text-secondary)">{moment(day).format("ddd")}</CommonTypo>
                        <CommonTypo size={14} lineHeight={14} color="var(--color-text-primary)">{moment(day).format("D")}{" "}</CommonTypo>
                    </div>
                );
            })}
        </div>
    );
};

const MobileAccordion = (props) => {
    const allIds = JSON.parse(localStorage.getItem("menuExpandIds") || '[]')
    const [expanded, setExpanded] = useState<boolean>(allIds.includes(props?.title) ? false : true);
    const handleChange = (expanded: boolean) => () => {
        setExpanded(!expanded);
        if (expanded) {
            const allIds = JSON.parse(localStorage.getItem("menuExpandIds") || '[]')
            if (allIds) {
                allIds.push(props?.title)
            }
            localStorage.setItem("menuExpandIds", JSON.stringify(allIds))
        } else {
            let allIds = JSON.parse(localStorage.getItem("menuExpandIds") || '[]')
            if (allIds && allIds.length) {
                allIds = allIds.filter(it => it !== props?.title)
            }
            localStorage.setItem("menuExpandIds", JSON.stringify(allIds))
        }
    };
    return (
        <Accordion
            sx={{ marginBottom: "0px", border: expanded ? "1px solid var(--color-border)" : "none", borderBottom: expanded ? "" : "1px solid var(--color-border)", marginTop: "16px", borderRadius: "12px", overflow: "hidden" }}
            elevation={0}
            expanded={expanded}
            onChange={handleChange(expanded)}
        >
            <AccordionSummary title={props?.title} cat={props?.cat} tooltipTitle={props?.tooltipTitle} integrationType={props?.integrationType} expanded={expanded} isToday={props?.isToday} />

            <AccordionDetails sx={{ padding: "0px" }}>
                {props?.children}
            </AccordionDetails>
        </Accordion>
    );
};